export interface SectionIntroProps {
  title: string;
  subtitle?: string;
}

/** Título de bloque con frase de apoyo ("¿En qué se va tu gasto?"). Es h2: el h1 lo tiene el encabezado. */
export function SectionIntro({ title, subtitle }: SectionIntroProps) {
  return (
    <div className="mb-4 mt-9 md:mb-5">
      <h2 className="m-0 mb-1 font-[var(--ds-font-display)] text-[22px] leading-7 tracking-[-0.02em] text-[var(--ds-ink)] md:text-[26px] md:leading-8">
        {title}
      </h2>
      {subtitle && <p className="m-0 text-sm leading-5 text-[var(--ds-ink-muted)] md:text-[15px] md:leading-[22px]">{subtitle}</p>}
    </div>
  );
}
